import { getLogger } from '../diagnostics/logger';
import {
  CLEAR_USER_ROLES,
  LOAD_USER_ROLES,
  LOAD_USER_ROLES_FAILURE,
  LOAD_USER_ROLES_SUCCESS,
} from '../actions/actionTypes';
import { Action, ActionMeta } from '../actions/commonActions';
import { Loadable } from '../models';
import { PageParameters } from '../models/account';
import { SimManagementError } from '../models/Errors';
import { QueryResult } from '../models/queryResult';
import { initialAppState } from '../models/state/appState';
import { getDefaultUserRolesState, UserRoles } from '../models/state/userRolesState';
const log = getLogger('simManagement.reducers.userRolesReducer');

/**
 * Reducer which deals with processing user roles.
 * @param state Initial state.
 * @param action An action.
 */
export default function userRolesReducer(
  state: Loadable<UserRoles> = initialAppState.userRoles,
  action: Action<any>,
): Loadable<UserRoles> {
  switch (action.type) {
    // user roles
    case CLEAR_USER_ROLES: {
      const newState = getDefaultUserRolesState();
      return newState;
    }
    case LOAD_USER_ROLES: {
      const { payload } = action as Action<PageParameters>;
      if (!payload) {
        log.warn('No payload');
        return state;
      }

      const newState = Object.assign({}, state, {
        companyId: payload.companyId,
        accountId: payload.accountId,
        isLoading: true,
      });

      return newState;
    }
    case LOAD_USER_ROLES_SUCCESS: {
      const { payload, meta } = action as ActionMeta<QueryResult<string>, PageParameters>;
      if (!payload) {
        log.warn('No payload');
        return state;
      }

      if (!meta) {
        log.warn('No meta');
        return state;
      }

      const roles: string[] = payload.result;
      const newState = {
        companyId: meta.companyId,
        accountId: meta.accountId,
        all: roles,
        byId: Object.assign({}, ...roles.map((a) => ({ [a]: true }))),
        isLoading: false,
        lastLoadedOn: new Date(),
      };

      return newState;
    }
    case LOAD_USER_ROLES_FAILURE: {
      const { payload, meta } = action as ActionMeta<SimManagementError, PageParameters>;
      if (!payload) {
        log.warn('No payload');
        return state;
      }

      if (!meta) {
        log.warn('No meta');
        return state;
      }

      const newState = Object.assign(getDefaultUserRolesState(), {
        companyId: meta.companyId,
        accountId: meta.accountId,
        error: payload,
      });

      return newState;
    }
  }

  return state;
}
